export enum RegistrationTypes {
    Bfutr = 'bfutr2024'
}